// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"749":"b7702696","903":"6c921eac","959":"b0e9b597"}[chunkId] + ".chunk.js";
};